import { render, staticRenderFns } from "./fragment-label.vue?vue&type=template&id=29247640&scoped=true&"
import script from "./fragment-label.vue?vue&type=script&lang=js&"
export * from "./fragment-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29247640",
  null
  
)

export default component.exports